import { render, staticRenderFns } from "./OauthTypeNotice.vue?vue&type=template&id=19711df4&scoped=true&"
import script from "./OauthTypeNotice.vue?vue&type=script&lang=ts&"
export * from "./OauthTypeNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19711df4",
  null
  
)

export default component.exports